import { createComponent } from '@lit-labs/react'
import React from 'react'
import { TimelineUser as TimelineUserComponent } from '../zaptic-timeline-user'

export const TimelineUser = createComponent({
    react: React,
    elementClass: TimelineUserComponent,
    tagName: 'zaptic-timeline-user',
})
